import CommunicationList from "features/BusinessConnections/CommunucationList/communication-list";

export enum Status {
    Success = '1',
    Error = '2',
    NoContent = '3',
    AdditionalInfo = '4',
    Unauthorized = '5'
}

export enum Culture {
    English = "en",
    German = "de",
    Serbian = "sr",
    Polish = "pl",
    Turkish = "tr",
}

export enum CultureToTranslate {
    German = "de",
    Serbian = "sr",
    Polish = "pl",
    Turkish = "tr",
}

export enum FinanceDocumentType {
    Request = "1",
    Offer = "2",
    Order = "3",
    OrderConfirmation = "4",
    Invoice = "5",
    Reminder = "6",
    Dunning = "7",
    CreditNote = "8",
    All = "-1"
}

export enum TextBlockPosition {
    BeforeTable = 1,
    AfterTable = 2
}

export enum AccountingNumberType {
    Sales = 1,
    Purchase = 2
}

export enum FinanceDocumentStatuses {
    Preparation = "1",
    Received = "2",
    Pending = "3",
    Approved = "4",
    Rejected = "5",
    Cancelled = "6",
    Sent = "7",
    Done = "8",
    Disputed = "9",
    Correction = "10"
}

export enum RequestType {
    IncomingFinanceRequest = 'Incoming finance request',
    OutgoingFinanceRequest = 'Outgoing finance request',
    IncomingOffer = 'Incoming offer',
    OutgoingOffer = 'Outgoing offer',
    IncomingOrder = 'Incoming order',
    OutgoingOrder = 'Outgoing order',
    IncomingInvoice = 'Incoming invoice',
    OutgoingInvoice = 'Outgoing invoice',
    IncomingOrderConfirmation = 'Incoming order confirmation',
    OutgoingOrderConfirmation = 'Outgoing order confirmation',
    IncomingReminder = 'Incoming reminder',
    OutgoingReminder = 'Outgoing reminder',
    IncomingDunning = 'Incoming dunning',
    OutgoingDunning = 'Outgoing dunning',
    HiringRequest = 'Hiring request',
    AbsenceRequest = 'Absence request',
    RefundRequest = 'Refund request',
    BonusCommissionRequest = 'Bonus and Comission request',
    SalaryDeductionRequest = 'Salary deduction request'
}

export enum RequestStatusIds {
    Approved = "1",
    Declined = "2",
    Pending = "3",
    Canceled = "4"
}

export enum RequestStatus {
    APPROVED = "Approved",
    DECLINED = "Declined",
    PENDING = "Pending",
    CANCELED = "Canceled",
}

export enum ExportFormat {
    ErsteBank_Serbia = 1,
    Halcom = 2,
    XML = 3,
    ErsteBank_Poland = 4
}

/** The XML (pain.001) export's payment type - FinanceEnums.PaymentType on the backend. */
export enum XmlPaymentType {
    AustrianStandard = 1,
    GermanStandard = 2,
    International = 3
}

export enum ModalTypes {
    FinanceDocuments_FinanceDocumentModal = 'FinanceDocumentModal',
    FinanceDocuments_ExportFileModal = 'ExportFileModal'
}

export enum PartnerType {
    Internal = "Internal",
    External = "External"
}

export enum ContractType {
    FlatRate = 1,
    HourlyRate = 2
}

export enum ProcedureType {
    Client = 1,
    Supplier = 2
}

export enum ContractTypeString {
    FlatRate = "Flat Rate",
    HourlyRate = "Hourly Rate"
}

export enum ProcedureTypeString {
    Client = "Sales",
    Supplier = "Purchase"
}

export enum TableType {
    Requests = 0,
    Offers = 1,
    Orders = 2,
    OrderConfirmations = 3,
    Invoices = 4,
    Reminders = 5,
    Dunnings = 6,
    OverviewsByCostCenter = 7,
    Partners = 8,
    Contacts = 9,
    ContractList = 10,
    NewApplicants = 11,
    AssignedApplicants = 12,
    HiringRequests = 13,
    Payments = 14,
    Articles = 15,
    Sources = 16,
    AdditionalInfoTemplates = 17,
    InactiveAdditionalInfoTemplates = 18,
    InactiveArticles = 19,
    Departments = 20,
    InactiveDepartments = 21,
    InactiveRoles = 22,
    Roles = 23,
    Employees = 24,
    InactiveEmployees = 25,
    InactiveTenants = 26,
    Tenants = 27,
    AccountingNumbers = 28,
    InactiveAccountingNumbers = 29,
    EmployeePositions = 30,
    InactiveEmployeePositions = 31,
    InactiveSources = 32,
    InactivePaymentMethods = 33,
    InactiveEmployeesPositions = 34,
    InactiveCategories = 35,
    ApplicantHistoryDTOs = 36,
    Educations = 37,
    Languages = 38,
    ExperienceRecords = 39,
    ProjectExperienceRecords = 40,
    Skills = 41,
    DealTab = 42,
    Deals = 43,
    FileImportTemplates = 44,
    Logs = 45,
    ImportPaymentsTab = 46,
    InactiveProjects = 47,
    Projects = 48,
    Templates = 49,
    AllRequests = 50,
    MyRequests = 51,
    Project = 52,
    Employee = 53,
    // No screen uses these two since the tenant location lists were replaced by the tenant page.
    // Table views are persisted per TableType, so the numbers stay taken: do not reuse them.
    InactiveTenantLocations = 54,
    TenantLocations = 55,
    TextblockTemplates = 56,
    Categories = 57,
    PaymentMethods = 58,
    resource_planning = 59,
    InactiveTemplates = 60,
    OfferForecast = 61,
    OrderPlanning = 62,
    UnassignedDocuments = 63,
    TxtFiles = 64,
    XmlFiles = 65,
    Positions = 66,
    RequestPositions = 67,
    Units = 68,
    InactiveUnits = 69,
    IndustrySectors = 70,
    PartnerTypes = 71,
    PaymentDrafts = 72,
    EducationTypes = 73,
    DealPipelines = 74,
    CashRegisterInflow = 75,
    CashRegisterOutflow = 76,
    CreditNote = 77,
    Participants = 78,
    ParticipantRoles = 79,
    InactiveParticipantRoles = 80,
    Holidays = 81,
    InactiveHolidays = 82,
    HolidaysGroup = 83,
    AbsenceType = 84,
    Absences = 85,
    Refunds = 86,
    InactiveRefunds = 87,
    MyAbsences = 88,
    BonusesCommissions = 89,
    MyBonusesCommissions = 90,
    InactiveBonusesCommissions = 91,
    AllSalaryDeductions = 92,
    MySalaryDeductions = 93,
    ProjectFiles = 94,
    InactiveSalaryDeductions = 95,
    TimeReport = 96,
    TimeReportByEmployee = 97,
    TimeReportByProject = 98,
    TimeReportByEmployeeAndProject = 99,
    CommunicationList = 100,
    AutomatedMessages = 101,
    InactiveAutomatedMessages = 102,
    // Travel/driver allowances used to reuse Sources/InactiveSources. Table views are persisted per
    // TableType, so all six screens shared one saved view and applied each other's column keys.
    TravelAllowances = 103,
    InactiveTravelAllowances = 104,
    DriverTravelAllowances = 105,
    InactiveDriverTravelAllowances = 106,
    TimeReportByProjectAllTenants = 107,
    // Drafts have their own columns, so they keep their own saved views instead of sharing Partners'.
    PartnerDrafts = 108,
    ContactDrafts = 109
}

export enum months {
    "January" = 1,
    "February" = 2,
    "March" = 3,
    "April" = 4,
    "May" = 5,
    "June" = 6,
    "July" = 7,
    "August" = 8,
    "September" = 9,
    "October" = 10,
    "November" = 11,
    "December" = 12
}

export enum DataTypes {
    WholeNumber = 1,
    DecimalNumber = 2,
    Text = 3,
    DropdownList = 4,
    Percentage = 5,
    Date = 6
}

export enum AdditionalInfoTemplateTypes {
    ProcedureDeal = 1,
    Skills = 2,
}

export enum SourceTypes {
    Finance = 1,
    Applicant = 2,
}

export enum UnassignedDocumentTypes {
    Public = 1,
    Private = 2
}

export enum ApplicantStatuses {
    InProgress = 1,
    Withdrew = 2,
    Declined = 3,
    Accepted = 4,
    Employed = 5
}

export enum Theme {
    light = 'light',
    dark = 'dark',
}

export enum SessionType {
    Work = 1,
    Break,
    Holiday,
    Absence,
    Travel
}

export enum SessionState {
    Stopped = 1,
    Working,
    OnBreak,
    Traveling
}

export enum TransportType {
    Car = 1,
    Flight = 2,
    Train = 3,
    Bus = 4
}

export enum TransportMethod {
    Private = 1,
    Company = 2,
    Public = 3
}